export const getRandomValue = val => Math.floor(Math.random() * val);

export const getLocationIndex = stageLocations => {
  // get available location of y in the stage then get the random position
  // [0, 1, 0, 0, 1, 1] => [1, 4, 5], random from result
  const availableLocations = stageLocations.reduce((acc, val, index) => {
    if (!!val) {
      acc.push(index);
    }

    return acc;
  }, []);

  const index = getRandomValue(availableLocations.length);

  return availableLocations[index];
};



// WEBPACK FOOTER //
// ./app/sagas/practiceUtils.js